import * as React from 'react';
import {Component} from 'react';
import cx from 'classnames';

interface TooltipProps {
    tooltipText: string;
    height?: number;
    componentClasses?: string;
    position?: 'right' | 'left';
    turn?: boolean;
    containerRef?: any;
}

interface TooltipState {
    isTurn: boolean;
}

export const withTooltip = <P = null,>(InnerComponent: React.ComponentType<P>) => {
    return class Tooltip extends Component<TooltipProps & P, TooltipState> {
        constructor(props) {
            super(props);

            this.state = {
                isTurn: props.turn
            };

            this.checkTurn = this.checkTurn.bind(this);
        }

        checkTurn(e) {
            const {containerRef, turn, height} = this.props;
            const placeForTooltip = height + 5;

            // check if turn should depend on container element
            if (containerRef && !turn) {
                if (
                    containerRef.current.offsetTop - containerRef.current.offsetParent.scrollTop <
                    placeForTooltip
                ) {
                    this.setState({isTurn: true});
                } else {
                    this.setState({isTurn: false});
                }
            }
        }

        render() {
            const {componentClasses, tooltipText, height, position, ...restProps} = this.props;
            const {isTurn} = this.state;
            const tooltipClass = cx('tooltip', {
                turnRight: isTurn && position === 'right',
                turnLeft: isTurn && position === 'left'
            });
            return (
                <div
                    className={cx('tooltip-wrapper', componentClasses)}
                    onMouseEnter={this.checkTurn}
                >
                    <InnerComponent {...(restProps as P)} />
                    <div className={tooltipClass} style={{height: height}}>
                        {tooltipText}
                    </div>
                </div>
            );
        }
    };
};
